import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/external-api/api.service";

import {IApplicationParametersState} from "../state/application-parameters/application-parameters.state";
import {ConfigurationManager} from "../../configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class TasksService2 {

  constructor(private apiService: ApiService, private configurationManager: ConfigurationManager) { }

  getTasksList(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['access-token'] = accessToken;
    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo; //apiReportingUrl
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    //return this.apiService.get(environment.apiPlatformUrl + '/tasks', requestParameters);
    return this.apiService.get(this.configurationManager.getApiUrl('apiReportingUrl') + '/tasks', requestParameters);
  }

  runReport(accessToken: string, datasourcePartyId: string, operationCode: string, operationParam) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['access-token'] = accessToken;
    requestParameters['operation_code'] = operationCode;
    requestParameters['operation-code'] = operationCode;
    requestParameters['datasourcepartyid'] = datasourcePartyId;
    if (this.configurationManager.configuration.auth.module === 'ldap' && this.configurationManager.configuration.auth.realm === 'auchan_ru') {
      requestParameters['body-param'] = encodeURIComponent(JSON.stringify(operationParam));
      operationParam = null;
    }
    return this.apiService.post(this.configurationManager.getApiUrl('apiReportingUrl') + '/tasks', requestParameters, operationParam);
  }

}
